import { Component, Input } from '@angular/core'

@Component({
  selector: 'brand-slider-container',
  styles: [`
    .brand-slider-left-detail {
      display: inline-block;
      width: 85px;
      margin-bottom: 4px;
      margin-right: 8px;
    }
    .brand-slider-right-detail {
      display: inline-block;
      margin-bottom: 4px;
      margin-left: 8px;
    }
    .center-marker {
      pointer-events: none;
      position: absolute;
      left: 50%;
      height: 85%;
      width: 1px;
      border-left: 1px dotted black;
      z-index: 1;
    }

    .brand-slider-slider {
      position: relative;
      display: inline-block;
    }

    .outer {
      white-space: nowrap;
      overflow: visible;
    }

    @media(max-width: 445px) {
      .brand-slider-left-detail {
        width: 73px;
      }
      .detail {
        font-size: 12px;
      }
    }
    @media(min-width: 992px) and (max-width: 1127px) {
      .brand-slider-left-detail {
        width: 73px;
      }
      .detail {
        font-size: 12px;
      }
    }
    @media screen and (-webkit-min-device-pixel-ratio:0) {
      .center-marker {
        top: 3px;
      }
    }
  `],
  template: `
    <div class="outer small-bottom-buffer">
      <div class="brand-slider-left-detail">
        <div class="detail float-right">{{leftDetail}}</div>
      </div>

      <div class="brand-slider-slider">
        <div class="center-marker"></div>
        <ng-content></ng-content>
      </div>

      <div class="brand-slider-right-detail">
        <div class="detail float-left">{{rightDetail}}</div>
      </div>
    </div>
  `
})
export class BrandSliderContainer {
  @Input() leftDetail: string;
  @Input() rightDetail: string;
}
